import { getEncodedUrlForVroom } from 'owa-data-provider-info-fetcher';
import AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';
import { format } from 'owa-string-utils';
import { parse as parseUrl } from 'url';
import getRequest, { FileProviderRequestSet } from '../utils/FileProviderQueryConfig';
import { getResponseFromFileProvider } from '../utils/getResponseFromFileProvider';
import { CreateSharingLinkFromFileProviderResult } from './CreateSharingLinkFromFileProviderResult';

export async function createSharingLinkFromOneDrivePro(
    originalUrl: string
): Promise<CreateSharingLinkFromFileProviderResult> {
    const request: FileProviderRequestSet = getRequest(AttachmentDataProviderType.OneDrivePro);
    const requestUrl: string = format(
        request.create_shared_link_request.requestUrlFormat,
        parseUrl(originalUrl).hostname,
        getEncodedUrlForVroom(originalUrl)
    );

    const responseText: string = await getResponseFromFileProvider(
        request.providerType,
        requestUrl,
        request.create_shared_link_request.additional_headers,
        request.create_shared_link_request.method,
        null, // request body
        originalUrl,
        request.create_shared_link_request.dataPointName
    );

    return JSON.parse(responseText).value[0];
}
